import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { StorageGroup } from '../storage-group'
import { StorageGroupDetailComponent } from '../storage-group-detail/storage-group-detail.component'

@Component({
  selector: 'app-storage-group-detail-side',
  templateUrl: './storage-group-detail-side.component.html',
  styleUrls: ['./storage-group-detail-side.component.scss'],
  imports: [StorageGroupDetailComponent],
})
export class StorageGroupDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public storageGroup: StorageGroup
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.storageGroup = route.snapshot.data['storageGroup']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.shellService.closeSideContent()
  }
}
